import { createAction } from 'redux-actions';

import { createActionBundle } from 'utilities/request';

export const deviceStatusesSubmit = createAction('DEVICE_STATUSES/SUBMIT');

export const {
  request: requestObservationUpdate,
  success: requestObservationUpdateSuccess,
  failure: requestObservationUpdateFailure,
} = createActionBundle('OBSERVATION_UPDATE');
